export const checkFilesSize = (files: FileList, limit: number) => {
  let size = 0;
  Object.values(files).forEach((file) => (size += file.size));
  return size <= limit ? true : false;
};
